import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import getAxpoCounterInvoiceDownloadUrl, {
  AxpoCounterInvoiceDownloadKind,
} from "../http/getAxpoCounterInvoiceDownloadUrl";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useAxpoCounterInvoiceDownload = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchDownloadUrl = async (
    pairingId: string,
    kind: AxpoCounterInvoiceDownloadKind
  ) =>
    getAxpoCounterInvoiceDownloadUrl(
      await getAuthTokenBlocking(getToken, relogin),
      pairingId,
      kind
    );

  return { fetchDownloadUrl };
};

export default useAxpoCounterInvoiceDownload;
